import { render, staticRenderFns } from "./ShareQuestion.vue?vue&type=template&id=4e924d5b"
import script from "./ShareQuestion.vue?vue&type=script&lang=js"
export * from "./ShareQuestion.vue?vue&type=script&lang=js"
import style0 from "./ShareQuestion.vue?vue&type=style&index=0&id=4e924d5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports